import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { SiteProvider } from "@/context/SiteContext";
import { Layout, Loader, SmoothScroll } from "@/components/Layout";
import Home from "@/pages/Home";
import Story from "@/pages/Story";
import Tree from "@/pages/Tree";
import Gallery from "@/pages/Gallery";
import Memoriam from "@/pages/Memoriam";
import Voices from "@/pages/Voices";
import Places from "@/pages/Places";
import Privacy from "@/pages/Privacy";
import Gate from "@/pages/Gate";
import Enterprise from "@/pages/Enterprise";
import Family from "@/pages/Family";
import Personal from "@/pages/Personal";
import Admin, { AdminLogin } from "@/admin/Admin";
import { GoogleReturn } from "@/components/VisitorWelcome";

const PreviewFlag = () => {
  const { search } = useLocation();
  useEffect(() => { if (new URLSearchParams(search).get("preview") === "1") sessionStorage.setItem("public_preview", "1"); }, [search]);
  return sessionStorage.getItem("public_preview") === "1" ? (
    <button className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[95] btn-gold btn-sm" onClick={() => { sessionStorage.removeItem("public_preview"); window.location.href = "/"; }} data-testid="exit-preview-btn">Public preview: this is what a stranger sees. Exit</button>
  ) : null;
};

const L = (el) => <Layout>{el}</Layout>;

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <GoogleReturn />;
  return (
        <Routes>

          <Route path="/" element={L(<Home />)} />
          <Route path="/story" element={L(<Story />)} />
          <Route path="/tree" element={L(<Tree />)} />
          <Route path="/gallery" element={L(<Gallery />)} />
          <Route path="/memoriam" element={L(<Memoriam />)} />
          <Route path="/voices" element={L(<Voices />)} />
          <Route path="/places" element={L(<Places />)} />
          <Route path="/privacy" element={L(<Privacy />)} />
          <Route path="/enterprise" element={L(<Enterprise />)} />
          <Route path="/enterprise/:id" element={L(<Enterprise />)} />
          <Route path="/family" element={L(<Family />)} />
          <Route path="/personal/:slug" element={L(<Personal />)} />
          <Route path="/gate" element={<Layout bare><Gate /></Layout>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={L(<Home />)} />
        </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <SiteProvider>
        <SmoothScroll />
        <Loader />
        <PreviewFlag />
        <Toaster theme="dark" position="top-center" />
        <AppRoutes />
      </SiteProvider>
    </BrowserRouter>
  );
}

export default App;
